export const SESSION_STORAGE_KEYS = {
  MOCKS: {
    SHOW_PAGE_BANNERS: 'mock:showPageBanners',
  },
};
